import React, { useState, useEffect } from 'react';
import JHApi from "../../../utils/JHApi"
import AdminJHApi from "../../../utils/AdminJHApi"
import { getDaysFromHistory, getNameFromEmail } from '../../../utils/utils';
import JourneyViewTwo from './JourneyViewTwo';

export default function JourneyData(props) {
    const isAdmin = props.isAdmin || false
    const isAuthed = props.isAuthed || false
    const isActiveJHUser = props.isActiveJHUser || isAdmin
    //const autoRefreshList = props.autoRefreshList

    const [userId, setUserId] = useState();
    const [talents, setTalents] = useState([]);
    const [filteredTalents, setFilteredTalents] = useState([]);
    const [filter, setFilter] = useState({'manager':[],'status':[], 'plan':[], 'seniority':[], 'need attention':[]});
    const [searchFields, setSearchFields] = useState({});
    const [adminLists, setAdminLists] = useState({});

    const [showedStep, setShowedStep] = useState(0);
    const [journeyData, setJourneyData] = useState({});
    const [explenations, setExplenations] = useState({});
    /*const [CSManagers, setCSManagers] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [plans, setPlans] = useState([]);
    const [extraData, setExtraData] = useState({});*/
    //const [resumes, setResumes] = useState([]);
    const [isLoadingAll, setIsLoadingAll] = useState(false);
    const [isLoadingClients, setIsLoadingClients] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [freezeHistory, setFreezeHistory] = useState([]);
    const [signedDate, setSignedDate] = useState();
    const [cycles, setCycles] = useState([]);
    const [upcomingPublish, setUpcomingPublish] = useState({});
    //const [upcomingMeeting, setUpcomingMeeting] = useState();
    //const [isError, setIsError] = useState(false);

    //const sawExplenations = journeyData.sawExplenations || {}

    useEffect(() => {
        if (!isAuthed){
            return
        }

        if (isAdmin && !userId){
            setIsLoadingClients(true)

            const showFrozen = filter['need attention'].includes('frozen for more than two months')

            const filterStatuses = showFrozen ? ['freezed'] : filter.status

            AdminJHApi.getPersonalJourneys({...searchFields, filterStatuses}, (results) => {
                setTalents(results.jobHuntUsers)
                setAdminLists(results.adminLists||{})

                if (results.jobHuntUsers.length > 0){
                    //setUserId(results.jobHuntUsers[0].userId)
                }

                setIsLoadingClients(false)
            })
        }
    }, [isAdmin, userId, isAuthed, searchFields, filter]);

    useEffect(() => {
        let paramsToPass = {getExplanations : true}

        if (!isAuthed || (isAdmin && !userId)){
            return
        }

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoadingAll(true)

        JHApi.getPersonalJourneyData(paramsToPass,(response)=>{
            if(response){
                setJourneyData(response.personaljourney);
                /*if (response.cycles || response.publishData || response.upcomingPublish){
                    setExtraData({cycles:response.cycles||[], publishData:response.publishData||{}, upcomingPublish:response.upcomingPublish})
                }*/

                if (response.cycles){
                    setCycles(response.cycles)
                }

                if (response.upcomingPublish){
                    setUpcomingPublish(response.upcomingPublish)
                }

                if (response.explenations){
                    setExplenations(response.explenations)
                }
                /*if (response.CSManagers){
                    setCSManagers(response.CSManagers)
                }*/
                /*if (response.statuses){
                    setStatuses(response.statuses)
                }*/
                /*if (response.plans){
                    setPlans(response.plans)
                }*/
                setFreezeHistory(response.freezeHistory || [])
                setSignedDate(response.signedDate)
                /*if (response.upcomingMeeting){
                    setUpcomingMeeting(response.upcomingMeeting)
                }*/
                setShowedStep(response.personaljourney.currentStep)
            } else {
                setJourneyData({});
                //setExtraData({})
                setExplenations({})
                //setCSManagers([])
                //setStatuses([])
                //setPlans([])
                setShowedStep(0)
                setFreezeHistory([])
                setSignedDate()
            }

            setIsLoadingAll(false)
        }, (error) => {
            if(error && error.response&& error.response.data&& error.response.data.error){
                console.log(error.response.data.error)     
            } else {
                console.log('Something went wrong')
            }
            setJourneyData({});
            //setExtraData({})
            setExplenations({})
            //setCSManagers([])
            //setStatuses([])
            //setPlans([])
            setShowedStep(0)

            setIsLoadingAll(false)
            //setIsError(true)
        })
    }, [isAdmin, userId, isAuthed]);

    useEffect(() => {
        let newTalents = []

        const showFrozen = filter['need attention'].includes('frozen for more than two months')

        const oneDay = 1000 * 60 * 60 * 24;
        const now = new Date();

        talents.forEach(talent => {
            let toShow = true;

            if (toShow && filter['manager'] && filter['manager'].length > 0){
                if (talent.csManager){
                    toShow = filter['manager'].includes(getNameFromEmail(talent.csManager));
                } else if(filter['manager'].includes('No Manager')){
                    toShow = true
                } else {
                    toShow = false
                }
            }

            if (toShow && (talent.status==='signed' || talent.status==='freezed' || talent.status==='not in galina' || talent.status==='out of service')){
                if(
                    !talent.safetyNetActive && 
                    !filter['status'].includes('signed') && 
                    !filter['status'].includes('freezed') && 
                    !filter['status'].includes('not in galina') &&
                    !filter['status'].includes('out of service') 
                    &&!searchFields.queryString && !searchFields.email
                ){
                    //toShow = (filter['other'].includes('have not active safety net') && talent.safetyNetExpireDate && talent.safetyNetExpireDate >= new Date().toISOString().substring(0, 10))
                    toShow = false
                }

                if (!toShow && showFrozen && talent.status === 'freezed' && talent.freezeHistory && talent.freezeHistory.length>0){
                    toShow = true;
                }
            }
            //['No Status', 'Active', 'Not Active']
            if (toShow && filter['status'] && filter['status'].length > 0){
                if (talent.status){
                    toShow = filter['status'].includes(talent.status);
                } else if(filter['status'].includes('No Status')){
                    toShow = true
                } else {
                    toShow = false
                }
            }

            if (toShow && filter['plan'] && filter['plan'].length > 0){
                if (talent.plan){
                    toShow = filter['plan'].includes(talent.plan);
                } else if(filter['plan'].includes('No Plan')){
                    toShow = true
                } else {
                    toShow = false
                }
            }

            if (toShow && filter['seniority'] && filter['seniority'].length > 0){
                toShow = (filter['seniority'].includes(talent.seniorityLevel||'not selected'))
            }

            if (toShow && filter['need attention'] && filter['need attention'].length > 0){
                toShow = false
                const daysSincelLastPublish = talent.lastPublishDate?Math.round((now - new Date(talent.lastPublishDate))/oneDay):0
                /*if (talent.lastPublishDate && filter['need attention'].includes('last publish 7-14 days')){    
                    toShow = (daysSincelLastPublish >=7 && daysSincelLastPublish <14)
                }*/
                if (!toShow && talent.lastPublishDate && filter['need attention'].includes('last publish more than 14 days')){
                    toShow = (daysSincelLastPublish >= 14)
                }
                /*if (!toShow && talent.currentStep===4 && filter['need attention'].includes('waiting for approval')){
                    toShow = !talent.isNeedTest && talent.lastTestId
                }*/

                if (!toShow && filter['need attention'].includes('waiting for approval')){
                    toShow = ('waiting for approval' === talent.status)
                }

                if (!toShow && talent.plan && talent.numberOfCycles!==0 && filter['need attention'].includes('last publication for standard')){
                    toShow = (talent.numberOfCycles===5 && talent.plan==='standard pro') || (talent.numberOfCycles===6 && talent.plan==='standard executive')
                }
                if (!toShow && talent.firstPartSent && filter['need attention'].includes('7th day first part sent')){
                    toShow = Math.round((now - new Date(talent.firstPartSent))/oneDay) === 7
                }
                if (!toShow && talent.firstPartSent && filter['need attention'].includes('more than 10 cycles')){
                    toShow = talent.numberOfCycles>=10
                }

                if (!toShow && talent.status === 'freezed' && talent.freezeHistory && talent.freezeHistory.length>0 && filter['need attention'].includes('frozen for more than two months')){
                    toShow = getDaysFromHistory(talent.freezeHistory, talent.beginServiceDate || talent.dateCreated) >= 60
                }
            }

            if (toShow){
                newTalents.push(talent)
            }
        });

        if (newTalents.length > 0){
            setUserId(newTalents[0].userId)
        } else {
            setUserId()
        }

        setFilteredTalents([...newTalents])
    }, [talents, filter, searchFields]);

    /*const handleStep = step => {
        setShowedStep(step)
    }*/

    const handleSaveData = (data, onSuccess, onError) => {
        let paramsToPass = {data}

        if (isAdmin){
            paramsToPass.userId = userId
        }
    
        setIsLoading(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            if(response.setStep){
                setShowedStep(response.personaljourney.currentStep)
            }
            if (onSuccess){
                onSuccess(response)
            }
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
            if (onError){
                onError(error)
            }
        })
    }

    /*const uploadPublishCVFile = event => {
        const maxUploadResumeSize = 50 * 1024; // 50 KB
        const file = event.target.files[0];

        if (!file) {
            return null
        }

        if(file.size > maxUploadResumeSize){
            setUplaodMessage('File too big - 50 KB Max')
            return null
        }
        
        const extension =  file.name.split('.').pop();
        if(!extension.match(/docx|pdf/ig)){
            setUplaodMessage('Invalid extension')
            return null
        }

        setIsLoading(true)
        setUplaodMessage('Uploading...')

        const data = new FormData()
        data.append('file', file, file.name)

        if (isAdmin){
            data.append('userId', userId)
        }

        JHApi.uploadPublishCVFile(data, (response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            setUplaodMessage('')
        }, (error)=>{
            setIsLoading(false)
            setUplaodMessage(error)
        });
    }*/

    const converToDocx = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.convertGoogleDocsToDocx(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            props.showMessageDialog('Convert Completed', 
                `Check the file, if incorect:
                1. Open CV on Google docs
                2. Select and copy all content of file (Ctrl + A, then Ctrl + C)
                3. Open new Word file, paste the content (Ctrl + V) 
                4. Save as Word file (.docx)
                5. Upload Word file here`, true)
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            props.showMessageDialog('Convert Failed', 
                `Check the file, if incorect:
                - Validate that the file is Google docs
                - Validate is shared with everyone
                If none of this help:
                1. Open CV on Google docs
                2. Select and copy all content of file (Ctrl + A, then Ctrl + C)
                3. Open new Word file, paste the content (Ctrl + V) 
                4. Save as Word file (.docx)
                5. Upload Word file here`, true)
            
            setIsLoading(false)
            //setIsError(true)
        })
    }

    const converToPdf = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.convertGoogleDocsToPdf(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            props.showMessageDialog('Convert Completed', `Check the file`)
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            props.showMessageDialog('Convert Failed', 
                `Check the file, if incorect:
                - Validate that the file is Google docs
                - Validate is shared with everyone`)
            
            setIsLoading(false)
            //setIsError(true)
        })
    }

    /*const sendTest = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.sendPersonalJourneyTest(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            props.showMessageDialog('Email sent', 'Test sent to email, please check your inbox')
        }, (error) => {
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
            
            setIsLoading(false)
            //setIsError(true)
        })
    }*/

    /*const startPublish = (beginPublish) => {
        let paramsToPass = {beginPublish}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.startPersonalJourneyPublish(paramsToPass,(response)=>{
            updateDataByRespone(response)
            setIsLoading(false)
        }, (error) => {
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
            
            setIsLoading(false)
        })
    }*/

    /*const updatePublish = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.updatePersonalJourneyPublish(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
        }, (error) => {
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
            
            setIsLoading(false)
        })
    }*/

    /*const handleNextStep = () => {
        if (showedStep === journeyData.currentStep && showedStep<=5){
            let paramsToPass = {}

            if (isAdmin){
                paramsToPass.userId = userId
            }

            setIsLoading(true)

            JHApi.finishPersonalJourneyStep(paramsToPass,(response)=>{
                setJourneyData(response.personaljourney);
                setIsLoading(false)
                setShowedStep(response.personaljourney.currentStep)
            }, (error) => {
                if(error && error.response&& error.response.data && error.response.data.error){
                    props.showMessageDialog('Error', error.response.data.error)
                } else {
                    props.showMessageDialog('Error', 'Something went wrong')
                }
                
                setIsLoading(false)
            })
        } else {
            setShowedStep(showedStep+1)
        }
    }*/

    /*const handleAddResume = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.addResume(paramsToPass,(response)=>{
            setResumes(response.resumes)
            setIsLoading(false)
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
        })
    }

    const handleUpdateResume = params => {
        let paramsToPass = params

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.updateResume(paramsToPass,(response)=>{
            setResumes(response.resumes)
            setIsLoading(false)
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
        })
    }*/

    /*const handleBackStep = () => {
        if (showedStep !== 0){
            setShowedStep(showedStep-1)
        }
    }*/

    const preServerCall = () => {
        setIsLoading(true)
    }

    const postServerCall = (error, response) => {
        if(error){
            props.showMessageDialog('Error', error)
        } else {
            updateDataByRespone(response)
        }

        setIsLoading(false)
    }

    const updateDataByRespone = response => {
        if(response){
            if(response.personaljourney){
                setJourneyData(response.personaljourney);
                if(!response.dontChangeStep){
                    setShowedStep(response.personaljourney.currentStep)
                }
            }
            /*if (response.cycles || response.publishData || response.upcomingPublish){
                setExtraData({cycles:response.cycles||[], publishData:response.publishData||{}, upcomingPublish:response.upcomingPublish})
            }*/

            if (response.cycles){
                setCycles(response.cycles)
            }

            if (response.upcomingPublish){
                setUpcomingPublish(response.upcomingPublish)
            }

            if (response.explenations){
                setExplenations(response.explenations)
            }
            /*if (response.CSManagers){
                setCSManagers(response.CSManagers)
            }*/
            /*if (response.upcomingMeeting){
                setUpcomingMeeting(response.upcomingMeeting)
            }*/
            /*if (autoRefreshList && response.jobHuntClients){
                props.updateHist(response.jobHuntClients, response.jobHuntClients.length)
            }*/
        }
    }


    /*const handleSetSeniority = newSeniority => {
        let paramsToPass = {data:{seniorityLevel:newSeniority}}

        if (isAdmin){
            paramsToPass.userId = userId
        }
    
        setIsLoading(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            if(response.setStep){
                setShowedStep(response.personaljourney.currentStep)
            }
        }, (error) => {
            setIsLoading(false)
            console.log(error)
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
        })
    }*/

    const propsStepsContent = {
        isAdmin,
        journeyData,
        showedStep,
        explenations,
        //resumes,
        handleSaveData,
        isLoading,
        userId,
        preServerCall,
        postServerCall,
        converToDocx,
        converToPdf,
        isActiveJHUser,
        setJourneyData,
        freezeHistory, 
        signedDate, 
        cycles,
        upcomingPublish,
        numberOfCycles: cycles.length,
        disabled: isLoadingAll || isLoading,
        isLoadingAll,
        setUserId,
        talents: filteredTalents,
        talentsNoFilter: talents,
        filter, setFilter,
        searchFields, setSearchFields, isLoadingClients,
        adminLists
        //handleAddResume,
        //handleUpdateResume
    }

    return (
        <>
            <JourneyViewTwo {...props} {...propsStepsContent}/>
        </>
    )
}